import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ContactChargeInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Cargo">
      {getFieldDecorator("contactCharge", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el cargo del contacto."
          }
        ],
        initialValue: implementerProfile?.contactCharge
      })(
        <Input
          disabled={isBusy}
          id="contactCharge"
          name="contactCharge"
          placeholder="Cargo"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
